
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-portal",
      function () {
        return require("private-next-pages/material-ui/react-portal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-portal"])
      });
    }
  